import {
    closeAllCallSockets,
    closeSocket,
    logoutSuccess,
    updateConnection,
    useDispatch
} from '@missionlabs/api'
import { useFeatureFlags } from '@missionlabs/feature-flags'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLogoutMutation } from 'shared/store'

import { clearAutoLogin } from './useAutoLogin'

export const useOnLogout = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { logout: clearFeatureFlagUser } = useFeatureFlags()

    const [logout] = useLogoutMutation()

    const handleLogout = useCallback(() => {
        dispatch(closeAllCallSockets())
        dispatch(closeSocket())
        dispatch(updateConnection({ status: 'NOT_CONNECTED' }))

        // Don't await the response
        logout()
        void clearFeatureFlagUser()

        dispatch(logoutSuccess())
        clearAutoLogin()
        navigate('/')
    }, [clearFeatureFlagUser, dispatch, logout, navigate])

    return { handleLogout }
}
